import React, { useState } from 'react';

import fileData from '../../../interface/props/table/files';
import DeckAssessmentModal from '../../modal/DeckAssessment/DeckAssessmentModal';
import {
  getDeckAssessmentDotTooltip,
  resolveDeckAssessmentDotStatus,
} from '../../../utils/notesOcr';
import Dot from './Dot';
import DeckAssessmentDot from './DeckAssessmentDot';
import ThumbnailAutomationDot from './ThumbnailAutomationDot';
import {
  resolveThumbnailAutomationReasonFromFile,
  resolveThumbnailAutomationStatusFromFile,
} from './thumbnailAutomationStatus';

import styles from './Status.module.css';

type Props = {
  document: fileData;
};

const Status: React.FC<Props> = ({ document }) => {
  const [deckModalOpen, setDeckModalOpen] = useState(false);
  const deckDotStatus = resolveDeckAssessmentDotStatus(
    document.fileType,
    document.fileDetails,
    document.center,
  );
  const canOpenNotesModal = Boolean(
    document.fileDetails?.deckAssessment ||
    document.fileDetails?.dppIdentification,
  );

  return (
    <div className={styles['status-container']}>
      <Dot status={document.uploaded} />
      <Dot status={document.scheduled} />
      {document.fileType === 'video' ? (
        <ThumbnailAutomationDot
          status={resolveThumbnailAutomationStatusFromFile(document)}
          reason={resolveThumbnailAutomationReasonFromFile(document)}
        />
      ) : (
        <span
          style={{ width: '1rem', height: '1rem', display: 'inline-block' }}
        />
      )}
      {document.fileType === 'notes' ? (
        <DeckAssessmentDot
          status={deckDotStatus}
          tooltip={getDeckAssessmentDotTooltip(
            document.fileDetails,
            document.center,
          )}
          onClick={canOpenNotesModal ? () => setDeckModalOpen(true) : undefined}
        />
      ) : (
        <span
          style={{ width: '1rem', height: '1rem', display: 'inline-block' }}
        />
      )}

      {deckModalOpen && (
        <DeckAssessmentModal
          opened={deckModalOpen}
          close={() => setDeckModalOpen(false)}
          document={document}
        />
      )}
    </div>
  );
};

export default Status;
